import state from './callState'
import getters from './callGetters'
import actions from './callActions'
import mutations from './callMutations'

export default {
  namespaced : true,
  state : state,
  getters : getters,
  actions : actions,
  mutations : mutations
}

